import React from "react";
import useMostPopularExtras from "../../../../hooks/shared/extras/useMostPopularExtras";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as PackStyles from "./styles/Pack";
import Extra from "../../common/extras/Extra";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import Popover from "../../../../../../../common-deprecated/components/popover/aem/Popover";

const MostPopularExtras = (): JSX.Element | null => {
    const { mostPopularExtras, modelName, onAddExtra, onRemoveExtra, onSetExtraOption } = useMostPopularExtras();
    const wltpPopupText = useBnbOptionalLabel("T1.disclaimerWltpShort");

    if (!mostPopularExtras.length) return null;

    return (
        <Flex.Row>
            <Flex.Col width={1}>
                <Type.H2 headingType="gamma" mb={2}>
                    <BnbLabel label="mostPopularTitle" />
                    {wltpPopupText && <Popover showOnClick content={wltpPopupText} />}
                </Type.H2>
                <Type.Text as="p" headingType="base" mb={0}>
                    <BnbLabel label="mostPopularIntroText" params={{ model: modelName }} />
                </Type.Text>
            </Flex.Col>
            <Flex.Col width={1} mt={5}>
                <PackStyles.SubTitle>
                    <BnbLabel label="mostPopularSubTitle" params={{ model: modelName }} />
                    <BnbLabel label="extrasCount" params={{ count: mostPopularExtras.length }} />
                </PackStyles.SubTitle>
                <PackStyles.Grid>
                    {mostPopularExtras.map((item) => (
                        <Extra
                            optional
                            enabled
                            background
                            key={item.extra.id}
                            extra={item.extra}
                            equipped={item.checked}
                            equippedOptionId={
                                item.checked && item.extra.selectedOptionId ? item.extra.selectedOptionId : ""
                            }
                            onSelect={() => {
                                if (item.checked) onRemoveExtra(item.extra);
                                else onAddExtra(item.extra);
                            }}
                            onOptionSelect={(optionId: string) => onSetExtraOption(item.extra, optionId)}
                        />
                    ))}
                </PackStyles.Grid>
            </Flex.Col>
        </Flex.Row>
    );
};

export default MostPopularExtras;
